import { ToolbarItem } from "./toolbarItem";
import { toast } from "react-toastify";

/**
 * @name - Save Project
 * @description - Toolbar item to save current project
 */
export class SaveProject extends ToolbarItem {
    protected onItemClick = async () => {
        try {

            //
           // debugger;
const currentProject = this.props.project;
const updatedProject = {
    ...currentProject,
    isProjectSaved : true, 
    isProjectExported : false,    
};
            //
            await this.props.actions.saveProject(updatedProject);
            toast.success(`${this.props.project.name} saved successfully!`);
        } catch (e) {
            toast.error(`Error saving ${this.props.project.name}`);
        }
    }
}
